import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"margin":"auto"} }

import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import { computed } from "vue";
import { MessageModule } from "@/store/modules/Message";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tickets = computed(() => TicketModule.CurrentTicketsFromClient);

const getMessages = async (ticketId: string) => {
	if (
		!AuthModule.token ||
		(ticketId === TicketModule.currentRoomID &&
			MessageModule.getMessages.length)
	)
		return;
	if (
		TicketModule.CurrentClientTickets.find(t => t._id === ticketId)?.agent.some(
			a => a._id === AuthModule.id
		)
	) {
		TicketModule.setActualRoom(ticketId);
		MessageModule.requestTicketsFromClient({
			token: AuthModule.token,
			client:
				TicketModule.CurrentClientTickets.find(t => t._id === ticketId)
					?.client[0]._id ?? "",
		});
		MessageModule.requestMessages({
			token: AuthModule.token,
			ticket: ticketId,
			reset: true,
		});

		return;
	}
	TicketModule.previewOldTicket({ ticketId: ticketId, viewActualTicket: true });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tickets), (ticket) => {
    return (_openBlock(), _createElementBlock("div", {
      key: ticket._id,
      class: "row d-flex justify-content-center mb-2"
    }, [
      _createVNode(_component_el_button, {
        class: "col-11 last-ticket",
        type: ticket.color,
        onClick: ($event: any) => (getMessages(ticket._id)),
        round: "",
        plain: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(`${ticket.interface} button-icon`)
          }, null, 2),
          _createElementVNode("div", _hoisted_1, _toDisplayString(ticket.createdAt), 1)
        ]),
        _: 2
      }, 1032, ["type", "onClick"])
    ]))
  }), 128))
}
}

})